module.exports = __webpack_public_path__ + "img/edc-youtap.bfb072d9.png";